export const minWindowHeightForAvatar = 598;
export const minWindowHeightForSeasonFooter = 700;
export const minWindowWidthForSeasonFooterImage = 700;
export const windowHeightThresholdForAdditionalYOffset = 1350;
